import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";
import lodash from "lodash";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  DASHBOARD_FIELDS,
  DASHBOARD_OPERATIONS,
  DASHBOARD_OPERATIONS_LIST,
  DASHBOARD_OPERATIONS_TAGAS,
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE,
  DEFAULT_COLOR,
  INDICATOR
} from "../../constants/DashboardTemplatesConstants";

@Component({
  name: "Indicator",
  components: {
    DynamicSelect
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class Indicator extends Vue {
  @Prop() indexSectionOfDashboard!: number;
  @Prop() optionsToIndicator!: DynamicSelectData[];
  @Prop() tagOrIndicator!: string;
  @Prop() tags!: IndicatorOrTag[];
  @Prop() indicators!: IndicatorOrTag[];
  @Prop() mainCollection!: string;
  @Prop() elementToEdit?: IndicatorOrTag;

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;

  indicatorForm = false;

  operation = [] as DynamicSelectData[];
  operationsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: lodash.cloneDeep(DASHBOARD_OPERATIONS_TAGAS),
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_OPERATION,
    hideDetails: false,
    required: true,
    attach: false
  };

  tag1 = [] as DynamicSelectData[];
  tag2 = [] as DynamicSelectData[];
  tagsFieldsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_TAG,
    hideDetails: false,
    required: true,
    attach: false
  };

  fieldToOperate = [] as DynamicSelectData[];
  fieldToOperateConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_TAG,
    hideDetails: false,
    required: true,
    attach: false
  };

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  enablefieldToOperate = false;
  enableOperationsSelect = false;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  indicatorOrTagName = "";
  queryToCreateTag = {};
  color = "";
  edgeTag = false;
  edgeColor = "";
  textColor = "";

  mounted() {
    if (this.tagOrIndicator == INDICATOR) {
      this.indicatorRender();
      return;
    }

    this.tagRender();
  }

  cancelIndicator() {
    this.cleanTag();
    this.cleanIndicator();
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CLOSE_INDICATOR_MODAL);
  }
  saveIndicatorOrTag() {
    if (this.tagOrIndicator == INDICATOR) {
      this.saveindicator();
      return;
    }
    this.saveTag();
  }

  saveindicator() {
    const payload = {
      indicatorOrTagName: this.indicatorOrTagName,
      tagOrIndicator: this.tagOrIndicator,
      formulaToCreateIndicator: [this.tag1, this.operation, this.tag2],
      show: false,
      color: this.color,
      edgeColor: this.edgeColor || DEFAULT_COLOR,
      textColor: this.textColor
    };

    const indicatorNameRepeated = this.indicators.find(
      indicator => indicator.indicatorOrTagName == this.indicatorOrTagName
    );
    if (
      indicatorNameRepeated &&
      indicatorNameRepeated.indicatorOrTagName !=
        this.elementToEdit?.indicatorOrTagName
    ) {
      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.INDICATOR_NAME_REPEATED);
      this.cleanIndicator();
      return;
    }
    this.cleanIndicator();
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CLOSE_INDICATOR_MODAL, payload);
  }

  saveTag() {
    const tagNameRepeated = this.tags.find(
      tag => tag.indicatorOrTagName == this.indicatorOrTagName
    );
    if (
      tagNameRepeated &&
      tagNameRepeated.indicatorOrTagName !=
        this.elementToEdit?.indicatorOrTagName
    ) {
      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.TAG_NAME_REPEATED);
      this.cleanTag();
      return;
    }

    const payload = {
      indicatorOrTagName: this.indicatorOrTagName,
      fieldToOperate: this.fieldToOperate,
      tagOrIndicator: this.tagOrIndicator,
      operation: this.operation,
      show: false,
      color: this.color,
      edgeColor: this.edgeColor || DEFAULT_COLOR,
      textColor: this.textColor
    };

    this.cleanTag();
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CLOSE_INDICATOR_MODAL, payload);
  }

  changeOperation() {
    if (this.operation[0].id == DASHBOARD_OPERATIONS.COUNT) {
      this.fieldToOperate[0] = {
        id: DASHBOARD_FIELDS.DOC_ID,
        name: DASHBOARD_FIELDS.DOC_ID,
        collection: {
          name: this.mainCollection,
          id: this.mainCollection
        }
      };
      return;
    }
    this.enablefieldToOperate = true;
  }

  indicatorRender() {
    this.tagsFieldsConfig.listAll = lodash
      .cloneDeep(this.tags)
      .map((tag: IndicatorOrTag) => ({
        id: tag.indicatorOrTagName,
        name: tag.indicatorOrTagName
      }));

    this.operationsConfig.listAll = lodash.cloneDeep(DASHBOARD_OPERATIONS_LIST);

    if (this.elementToEdit?.indicatorOrTagName) {
      this.indicatorOrTagName = this.elementToEdit.indicatorOrTagName;
      this.tag1.push(this.elementToEdit.formulaToCreateIndicator![0 as number]);
      this.operation.push(
        this.elementToEdit.formulaToCreateIndicator![1 as number]
      );
      this.tag2.push(this.elementToEdit.formulaToCreateIndicator![2 as number]);
      this.color = this.elementToEdit.color || "";
      this.edgeColor = this.elementToEdit.edgeColor || "";
      this.textColor = this.elementToEdit.textColor || "";

      if (this.edgeColor !== DEFAULT_COLOR) {
        this.edgeTag = true;
        return;
      }
      this.edgeTag = false;
    }
  }

  resolveTagToIndicator() {
    this.tags.find(tag => tag.indicatorOrTagName == this.indicatorOrTagName);
  }

  tagRender() {
    this.fieldToOperateConfig.listAll = lodash
      .cloneDeep(this.optionsToIndicator)
      .filter(option => option.type == DATA_TYPE.NUMBER)
      .map(option => ({
        id: option.id,
        name: `${option.name} (${option.collection?.name})`,
        collection: option.collection
      }));

    if (this.elementToEdit?.indicatorOrTagName) {
      this.indicatorOrTagName = this.elementToEdit.indicatorOrTagName;
      this.fieldToOperate = this.elementToEdit.fieldToOperate || [];
      this.operation = this.renderOperation(
        this.elementToEdit.operation!
      ) as DynamicSelectData[];
      this.color = this.elementToEdit.color || "";
      this.edgeColor = this.elementToEdit.edgeColor || "";
      this.textColor = this.elementToEdit.textColor || "";
    }
  }

  renderOperation(operation: { id: string; name: string }[] | string) {
    if (typeof operation == DATA_TYPE.STRING) {
      const operationFound = this.operationsConfig.listAll.find(
        op => op.id == operation
      );
      return [operationFound];
    }
    return operation;
  }

  cleanTag() {
    this.indicatorOrTagName = "";
    this.fieldToOperate = [];
    this.operation = [];
    this.color = "";
  }

  cleanIndicator() {
    this.indicatorOrTagName = "";
    this.tag1 = [];
    this.operation = [];
    this.tag2 = [];
    this.color = "";
  }
}
